import React from "react";

import "./style.css";

import {
  MainNavBar,
  ArtistProfileSection1,
  ArtistProfileSection2,
  ArtistProfileSection3,
  Footer,
  LineSeperator,
} from "../../UIcomponents/UiComponents";
import { useQuery } from "react-query";
import artistsRequests from "../../../services/helpers/artistsquery";
import { usePageHead } from "../../../common/UpdateMetaAndTitle";
import { metaFromRecord } from "../../../common/seoUtils";
import { withRouter } from "react-router";

// language context
import LocalizationContext from "../../../localization/LocalizationContext";

function EmployeeProfile(props) {
  // i18n and current app language
  const { t, i18n } = React.useContext(LocalizationContext);
  const appLanguage = i18n.language;

  const { profileID } = props.match.params;

  //getArtistByID from url
  let queryDataGetArtist = {
    resource: "employees",
    id: profileID,
  };
  const getArtistdyIDQueryData = useQuery(
    ["getArtistdyID", queryDataGetArtist],
    () => artistsRequests.getArtistdyID(queryDataGetArtist)
  );

  const _employeeMeta = getArtistdyIDQueryData.data
    ? metaFromRecord(getArtistdyIDQueryData.data, "employee")
    : { title: t("Employee Profile") };
  usePageHead({ ..._employeeMeta, path: props.location.pathname });

  return (
    <>
      {getArtistdyIDQueryData.data && (
        <>
          <MainNavBar
            backUrl="/about"
            pageTitle={`${getArtistdyIDQueryData.data.name}`}
            bgClass="bg-white"
          />
          <div className="content-container-wrapper">
            <div className="content-container-content">
              <>
                <ArtistProfileSection1
                  queryData={getArtistdyIDQueryData}
                  t={t}
                />
                <ArtistProfileSection2
                  queryData={getArtistdyIDQueryData}
                  t={t}
                />
                {/* <ArtistProfileSection3 queryData={getArtistdyIDQueryData} /> */}
              </>
            </div>
          </div>
          <div className="employeeprofile__bottom-sep"></div>
          <Footer />
        </>
      )}
    </>
  );
}

export default withRouter(EmployeeProfile);
